import {
  getFirestore,
  collection,
  doc,
  setDoc,
  serverTimestamp,
  onSnapshot,
  updateDoc,
  deleteDoc,
  where,
  query,
  getDocs,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { app } from "config/config";
import { REF } from "store/ref";

const firestore = getFirestore(app);
const auth = getAuth();
// ========= firebase function =========//
export const addToken = async ({ token }) => {
  try {
    if (!token) throw new Error("LOST TOKEN");
    const cRef = collection(firestore, REF.TOKEN);

    const c0 = where("token", "==", token);
    const qRef = query(cRef, c0);
    const snapshot = await getDocs(qRef);
    if (!snapshot.empty)
      return {
        status: 404,
        data: snapshot?.docs?.[0]?.data(),
      };

    const id = doc(cRef).id;
    const dRef = doc(cRef, id);
    const create = {
      id,
      token,
      createAt: serverTimestamp(),
    };
    await setDoc(dRef, create);
    return {
      status: 200,
      data: create,
    };
  } catch (error) {
    console.log(error);
    return { status: 500, data: error?.message ?? "ERROR_0001" };
  }
};
// ========= cloud function =========//
// ========= local function =========//
// ========= dispatch =========//
